import React from "react";
import styles from "./styles.module.scss";
import SiteWrapper from "../../SiteWrapper";
import ContentGutter from "../../ContentGutter";
import FullHeight from "../../FullHeight";
import RoundButton from "../../RoundButton";
import t from "../../../utils/translate";

export default function Error({ retry }) {
  return (
    <div>
      <FullHeight>
        <div className={styles.main}>
          <ContentGutter>
            <SiteWrapper size="small">
              <div className={styles.header}>{t("RESULTS_ERROR")}</div>
              <div className={styles.options}>
                <RoundButton className={styles.errorCtaButton} onClick={retry}>
                  {t("REFRESH_RESULTS")}
                </RoundButton>
              </div>
            </SiteWrapper>
          </ContentGutter>
        </div>
      </FullHeight>
    </div>
  );
}
